import './ButtonWhite.css'

const ButtonWhite=(props)=>{
    return(
        <button className='buttonWhite-main' >
            {props.buttonName}
        </button>
    )
}
export default ButtonWhite;